module.exports = __webpack_public_path__ + "img/7-None.3e766402.png";